import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { Field, TextInput, inputCls } from "./Field";
import { SubmitButton, SuccessPanel } from "./SubmitButton";

export const ROLES = [
  "Housekeeping Staff", "Housekeeping Supervisor", "Electrician / Technician", "IT Support Engineer",
  "Payroll Executive", "Scanning Operator", "Data Entry Operator", "Driver", "Warehouse Associate", "Other",
];

const EMPTY = { full_name: "", phone: "", email: "", role: "", experience_years: "", location: "", skills: "" };

export const ApplicationForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/applications", form);
      setDone(true);
      toast.success("Application submitted.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return <SuccessPanel testId="application-success" title="Application in." text="Our HR team reviews every application and will call you if your profile matches an opening."
      onReset={() => { setForm(EMPTY); setDone(false); }} />;
  }

  return (
    <form onSubmit={submit} className="grid gap-x-8 gap-y-8 sm:grid-cols-2" data-testid="application-form">
      <TextInput id="apply-name" label="Full name" required value={form.full_name} onChange={set("full_name")} placeholder="Your name" />
      <TextInput id="apply-phone" label="Phone" type="tel" required value={form.phone} onChange={set("phone")} placeholder="+91" />
      <TextInput id="apply-email" label="Email" type="email" required value={form.email} onChange={set("email")} placeholder="you@email.com" />
      <Field id="apply-role" label="Role applying for" required>
        <select id="apply-role" required value={form.role} onChange={set("role")} className={`${inputCls} [&>option]:bg-[var(--ink)]`} data-testid="apply-role-select">
          <option value="" disabled>Select a role</option>
          {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
      </Field>
      <TextInput id="apply-experience" label="Experience (years)" value={form.experience_years} onChange={set("experience_years")} placeholder="e.g. 3" />
      <TextInput id="apply-location" label="Current location" value={form.location} onChange={set("location")} placeholder="City" />
      <Field id="apply-skills" label="Skills & past work" className="sm:col-span-2">
        <textarea id="apply-skills" rows={4} value={form.skills} onChange={set("skills")} className={`${inputCls} resize-none`}
          placeholder="Tell us about your skills, certificates and previous employers" data-testid="apply-skills-input" />
      </Field>
      <div className="sm:col-span-2">
        <SubmitButton loading={loading} testId="application-submit-button">Submit application</SubmitButton>
      </div>
    </form>
  );
};
